
export const LightView = (): JSX.Element | null => {
    return (
        <></>
    );
}
